import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GeoSearchInput from '../../components/geo-search-input';
import SearchMapContainer from '../../components/search-map-container';
import SmallAreaList from '../../components/small-area-list';
import * as selectors from '../../reducers';
import styles from './search-page.module.scss';
import {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
} from '../../actions/ui';
import { ChevronDoubleRight } from '../../components/icons';
import { labelMatcher, entityLabelMatcher } from '../../helpers/label-mapper';

class SearchPage extends Component {
  constructor() {
    super();
    this.selectCouncil = this.selectCouncil.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }
  selectCouncil(councilId) {
    const { setActiveRegion, setActivePage } = this.props;
    setActiveRegion(councilId);
    setActivePage('region');
  }

  selectEntity(entityId) {
    const { setActiveEntity, setActivePage } = this.props;

    setActiveEntity(entityId);
    setActivePage('entity');
  }

  handleListClick(council) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectCouncil(council.id);
    };
  }

  handleEntityListClick(entity) {
    return (e) => {
      window.scrollTo(0, 0);
      this.selectEntity(entity.id);
    };
  }

  renderCouncils() {
    const { regions } = this.props;
    return (
      <ul className={styles.councilList}>
        {regions
          .filter((c) => {
            // Don't make a page for the "Other- inside or outside QLD" category
            return !c.name.includes('Other');
          })
          .map((council, i) => (
            <li key={council + i} className={styles.councilListElement}>
              <button
                type="button"
                className={styles.councilListElementButton}
                onClick={this.handleListClick(council)}
              >
                {council.name}
              </button>
            </li>
          ))}
      </ul>
    );
  }
  render() {
    var entityGroupOrdering = {}, // map for efficient lookup of sortIndex
      entityGroupSortOrder = [
        'Energy generator',
        'Energy transmitter and distributor',
        'Energy retailer',
      ];

    for (var i = 0; i < entityGroupSortOrder.length; i++) {
      entityGroupOrdering[entityGroupSortOrder[i]] = i;
    }

    var entityOrdering = {}, // map for efficient lookup of sortIndex
      entitySortOrder = [
        'CleanCo',
        'CS Energy',
        'Stanwell',
        'Powerlink',
        'EQL',
        'EEQ',
      ];

    for (var j = 0; j < entitySortOrder.length; j++) {
      entityOrdering[entitySortOrder[j]] = j;
    }

    const entityGroups = Object.keys(
      groupBy(this.props.entities, 'entityType')
    ).sort(function (a, b) {
      return (
        entityGroupOrdering[a] - entityGroupOrdering[b] || a.localeCompare(b)
      );
    });

    const allEntities = this.props.entities.sort(function (a, b) {
      return (
        entityOrdering[a.name] - entityOrdering[b.name] ||
        a.name.localeCompare(b.name)
      );
    });

    return (
      <div>
        <div className={styles.searchPageHeader}>
          <div className={styles.mainHeading}>
            Understanding the energy network
          </div>
          <hr className={styles.mainHeadingLine} />
          <div className={styles.subHeading}>
            Find your region in this Queensland Audit Office visualisation to
            explore information on energy entities for 2020 and compare to other
            regions. This interactive tool includes data on revenue, expenses,
            assets and liabilities. Data is included for the six government
            owned energy entities in Queensland.
          </div>
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Search the map</h3>
          <div className={styles.searchWrapper}>
            <GeoSearchInput onCouncilSelect={this.selectCouncil} />
          </div>
          <div className={styles.mapRow}>
            <div className={styles.mapWrapper}>
              <SearchMapContainer onCouncilSelect={this.selectCouncil} />
            </div>
            <div className={styles.entityListWrapper}>
              <div className={styles.entityListWrapperInner}>
                <div>
                  <ul>
                    {entityGroups.map((groupName, i) => {
                      const entitiesInClass = this.props.entities.filter(
                        (x) => x.entityType === groupName
                      );

                      return entitiesInClass
                        ? [
                            <li key={groupName + i}>
                              <p className={styles.subHeading}>
                                {entityLabelMatcher(groupName, 'plural')}
                              </p>
                            </li>,
                            allEntities
                              .filter((x) => x.entityType === groupName)
                              .map((e, i) => {
                                return (
                                  <li
                                    onClick={this.handleEntityListClick(e)}
                                    key={e.name}
                                    role="button"
                                    className={styles.li}
                                  >
                                    <ChevronDoubleRight
                                      fill="blue"
                                      width="10px"
                                      height="10px"
                                      style={{
                                        marginRight: 10,
                                        height: 10,
                                        width: 10,
                                      }}
                                    />
                                    {labelMatcher(e.name)}
                                  </li>
                                );
                              }),
                          ]
                        : null;
                    })}
                  </ul>
                  <p className={styles.entitylistNote}>
                    CS Energy and Stanwell also participate in the retail market
                    in Queensland.
                  </p>
                </div>
                <div className={styles.entitylistNote}>
                  Regions are based on ABS Statistical Areas (SA4 & SA3). Data
                  has been extracted by Local Government Area (LGA) and
                  subsequently mapped to the regions based on the ABS 2018 LGA
                  to SA4/3 mapping.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.section}>
          <h4 className={styles.smallerCouncilHeadline}>Smaller regions</h4>
          <p className={styles.smallerCouncilText}>
            Less than 1,000 km<sup>2</sup>
          </p>
          <SmallAreaList onClick={this.handleListClick} />
        </div>
        <div className={styles.section}>
          <h3 className={styles.sectionHeading}>Select from list</h3>
          <div className={styles.listWrapper}>{this.renderCouncils()}</div>
        </div>
      </div>
    );
  }
}

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const mapDispatchToProps = {
  setActiveRegion,
  setActivePage,
  setActiveEntity,
};

const mapStateToProps = (state) => ({
  regions: selectors.getRegions(state),
  entities: selectors.getEntities(state),
});

SearchPage.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object),
  entities: PropTypes.arrayOf(PropTypes.object),
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setActiveEntity: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);



// WEBPACK FOOTER //
// ./src/pages/search-page/search-page.js